export const DEFAULT_ICON_SIZES = {
  left: '2.125rem',
  right: '3rem',
};
